import React from "react";
import { Card, Box, Typography } from "@mui/material";

const TaskSummaryCard = ({ icon, label, value }) => {
  return (
    <Card
      sx={{
        border: "1px solid #4CAF50",
        borderRadius: "18px",
        boxShadow: "0 2px 6px 0 rgba(60, 72, 88, 0.08)",
        p: 2.5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: 120,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box
          sx={{
            border: "1px solid #4CAF50",
            borderRadius: "12px",
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
            padding: "10px",
          }}
        >
          <img src={icon}   style={{ width: "20px", height: "20px" }}/>
        </Box>
        {/* <Box
          sx={{
            border: "1px solid #4CAF50",
            borderRadius: "12px",
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
          }}
        >
          <Typography fontWeight={700} color="#4CAF50">...</Typography>
        </Box> */}
      </Box>
      <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="h6" fontWeight={700} color="#222">
          {value}
        </Typography>
      </Box>
    </Card>
  );
};

export default TaskSummaryCard; 